import React from 'react';
import { Box, Button, Dropdown, Select, Checkbox, Image, Alert, Typography, Grid, TextField, Calendar } from '@iho-design-system/Loader';
import moment from 'jalali-moment';



import CalendarSVG from '../../assets/images/icons/calendar.svg';
import profileImg from '../../assets/images/icons/user-profile.svg';
import iconDownSVG from '../../assets/images/icons/chevron-down.svg';
import getAPI from './../../api/get';
import AgencyProfile from '../../api/edit/AgencyProfile';

export default function OfficerInfo() {
    
    const [IsCeo, setIsCeo] = React.useState(false);
    const [BirthDateInfo, setBirthDateInfo] = React.useState('');
    const [Errs, setErrs] = React.useState(['']);
    const [Success, setSuccess] = React.useState(false);
    const [ResponsibleInfo, setResponsibleInfo] = React.useState({
        BirthDate: "",
        Email: '',
        FirstName: '',
        Gender: 0,
        LastName: "",
        Mobile: "",
        JobPosition: "",
        Confirmed: false,
        ResponsibleIsCeo: false

    })
    const typeUser = localStorage.getItem('userType');

    /*
       - alert
   */
    const [alert, setAlert] = React.useState('');
    const [alertColor, setAlertColor] = React.useState('success');
    const [alertStatus, setAlertStatus] = React.useState('d-none');
    const alertProps = (config) => {
        setAlert(config[1])
        setAlertColor(config[0]);
        setAlertStatus('d-flex');
        setTimeout(() => {
            setAlertStatus('d-none');
        }, 3000);
    }
    /*
           - toggleCaldendar
       */
    const toggleCalendar = (event, calendar) => {
        if (event.target.tagName === 'INPUT' && calendar === 'BirthDate') {
            setBirthDateInfo('');
        }


        if (event.target.tagName === 'DIV' || event.target.tagName === 'INPUT') {
            document.querySelector(`.${calendar}`).classList.toggle('d-none');
        }
    }
    const fetchData = async () => {



        let userTypeParameters = {
            ctrl: 'AgencyProfile',
            method: 'GetResponsibleInfo',
            query: ''
        }







        let response = await getAPI(userTypeParameters);
        if (response.status == 200) {
            setResponsibleInfo({ //response.data
                ...response.data
            });
           // setIsCeo(response.data.ResponsibleIsCeo);
            // if(response.data.ResponsibleIsCeo){
            //     document.querySelector('.is-ceo').checked = true;
            // }
            setBirthDateInfo(response.data.BirthDate ? moment(response.data.BirthDate.split('T'), 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD') : '');


        }


    }
    React.useEffect(() => {

        fetchData();
    }, []);

    /*
         - editUserProfileHandler
     */
    const editResponsibleInfo = (key, value) => {
        switch (key) {
            case 'BirthDate':
                setBirthDateInfo(value);
                setResponsibleInfo((prevState) => ({
                    ...prevState,
                    BirthDate: moment.from(value, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
                }))
                break;
            case 'Email':
                setResponsibleInfo((prevState) => ({
                    ...prevState,
                    Email: value
                }))
                break;
            case 'FirstName':
                setResponsibleInfo((prevState) => ({
                    ...prevState,
                    FirstName: value
                }))
                break;
            case 'LastName':
                setResponsibleInfo((prevState) => ({
                    ...prevState,
                    LastName: value
                }))
                break;
            case 'Gender':
                setResponsibleInfo((prevState) => ({
                    ...prevState,
                    Gender: value
                }))
                break;
            case 'Mobile':
                setResponsibleInfo((prevState) => ({
                    ...prevState,
                    Mobile: value
                }))
                break;
            case 'JobPosition':
                setResponsibleInfo((prevState) => ({
                    ...prevState,
                    JobPosition: value
                }))
                break;
            case 'ResponsibleIsCeo':
    
                setResponsibleInfo((prevState) => ({
                    ...prevState,
                    ResponsibleIsCeo: value
                }))

                if (value == true) {
                  //  setIsCeo(true);
                    getDataBoss(value);

                } 
                else {
                 //   setIsCeo(false);

                //  fetchData();
                }


                break;




            default:
                break;
        }

        
    }


    const handleSubmit = async (e) => {
        setErrs(['']);
        e.preventDefault();
        // Validate BirthDate field



        let isSend = true;
        // Validate FirstName field
        if (!ResponsibleInfo.FirstName) {
            setErrs(prevErrors => [...prevErrors,  'نام نباید خالی باشد']);
        
          isSend = false;
        }

        // Validate LastName field
        if (!ResponsibleInfo.LastName) {
            setErrs(prevErrors => [...prevErrors,  'نام خانوادگی نباید خالی باشد']);
        
            isSend = false;

        }
        if (!ResponsibleInfo.Gender || ResponsibleInfo.Gender == '0') {
            setErrs(prevErrors => [...prevErrors,  ' جنسیت نباید خالی باشد']);
        
            isSend = false;

        }


        // Validate Mobile field
        if (!ResponsibleInfo.Mobile) {
            setErrs(prevErrors => [...prevErrors, 'تلفن همراه نباید خالی باشد']);


         
            isSend = false;

        } else {
            // You can add a regular expression or any other mobile validation logic here
            const mobileRegex = /^[\u06F0-\u06F90-9]+$/;
            if (!mobileRegex.test(ResponsibleInfo.Mobile)) {
                setErrs(prevErrors => [...prevErrors, 'از اعداد برای تلفن همراه استفاده کنید']);
          
            
                isSend = false;

            }
        }

        // Validate JobPosition field
        if (!IsCeo) {
         if(!ResponsibleInfo.JobPosition){
            setErrs(prevErrors => [...prevErrors, 'سمت سازمانی نباید خالی باشد']);
           
              isSend = false;
         }
        }
        let result = await AgencyProfile('method', ResponsibleInfo);
        window.scrollTo(0,0);
        setErrs([]);
        if (result.status === 'success') {
            alertProps(['success', 'با موفقیت ثبت شد']);
            setSuccess(true);

        } else {
            if (result.data.Errors) {
                setSuccess(false);

                // let itemErr = '';
                result.data.Errors.forEach(item => {
                    //   const itemErr = item.toString();
                    setErrs(prevErrors => [...prevErrors, item]);
                    alertProps(['danger', item]);

                });
            }
        }

        if(isSend){
            let method = 'SaveResponsibleInfo';

            ResponsibleInfo.ResponsibleIsCeo = IsCeo;
    
            let result = await AgencyProfile(method, ResponsibleInfo);
            window.scrollTo(0,0);
           
            if (result.status === 'success') {
                alertProps(['success', 'با موفقیت ثبت شد']);
                setSuccess(true);
    
            } else {
                if (result.data.Errors) {
                    setSuccess(false);
    
                    // let itemErr = '';
                    result.data.Errors.forEach(item => {
                        //   const itemErr = item.toString();
                        setErrs(prevErrors => [...prevErrors, item]);
                        alertProps(['danger', item]);
    
                    });
    
    
                } else {
                    setSuccess(false);
                    alertProps(['danger', result.data.Message]);
                }
            }
        }else{
            alertProps(['danger', Errs]);

        }
        



    }
    const getDataBoss = async (isSend) => {

        let userTypeParameters = {
            ctrl: 'AgencyProfile',
            method: 'GetCeoInfo',
            query: ''
        }






        if (isSend) {
            let response = await getAPI(userTypeParameters);
            if (response.status == 200) {
                setResponsibleInfo({ //response.data
                    ...response.data
                });
                setResponsibleInfo((prevState) => ({
                    ...prevState,
                    ResponsibleIsCeo: true
                }))

            }
        }

    }


    const resetForm = () => {
        setResponsibleInfo({});
        setErrs(['']);
    }



    return (
        <React.Fragment>
            <form onSubmit={handleSubmit}
                method="POST"  >
                <Box
                    className={`bg-white rounded-lg border-solid border-light p-xl`}>

                    <Grid>
                        <Grid.Wrapper>
                            <Grid.Item
                                size='col-8'>
                                  
                                <Grid.Wrapper>
                                    <Grid.Item
                                        className={`border-solid-bottom border-light`}
                                        size='col-12'>
                                        <Typography ms={{
                                            fontWeight: 'bold'
                                        }}>
                                            اطلاعات تماس مسئول


                                        </Typography>
                                    </Grid.Item>
                                    <Grid.Item className={``}
                                        size='col-12'>


                                        <label>
                                            <input type="checkbox"
                                                className="form-chek"
                                                onChange={(status) => {

                                                    //setIsCeo(status.currentTarget.checked);
                                                    editResponsibleInfo('ResponsibleIsCeo', status.currentTarget.checked);
                                                }}
                                                defaultChecked={ResponsibleInfo.ResponsibleIsCeo == true ? 'true' : 'false'}  />
                                            <span className={`mx-md`}>مسئول همان مدیر عامل است</span>

                                        </label>


                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-6'>
                                        <TextField

                                            onChange={(event) => editResponsibleInfo('FirstName', event)}

                                            value={ResponsibleInfo.FirstName ? ResponsibleInfo.FirstName : ''}
                                            label='  نام '

                                        />
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-6'>

                                        <TextField
                                            value={ResponsibleInfo.LastName ? ResponsibleInfo.LastName : ''}
                                            label=' نام خانوادگی'

                                            onChange={(event) => editResponsibleInfo('LastName', event)}

                                        />

                                    </Grid.Item>
                                    <Grid.Item
                                        className={`position-relative`}
                                        size='col-6'>
                                        <Box
                                            onClick={(event) => toggleCalendar(event, 'BirthDate')}>
                                            <TextField
                                                label='تاریخ تولد (اختیاری)'
                                                onChange={(event) => editResponsibleInfo('BirthDate', event)}
                                                icon={CalendarSVG}
                                                // value={(getDataBaseB2B.RegisterDate) ? moment(getDataBaseB2B.RegisterDate.split('T')[0], 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD') : advancedSearchInsertDate} 
                                                value={BirthDateInfo ? BirthDateInfo : ''}
                                            />

                                            <Box
                                                className={`BirthDate d-none position-absolute`}
                                                ms={{
                                                    width: '320px',
                                                    top: 'calc(75px + var(--sizing-xs))',
                                                    zIndex: '1'
                                                }}>
                                                <Calendar
                                                    onChange={(event) => editResponsibleInfo('BirthDate', event)} />
                                            </Box>
                                        </Box>
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-6'>
                                        <Select
                                            onChange={(event) => editResponsibleInfo('Gender', event)}

                                            label='جنسیت'

                                            init={ResponsibleInfo.Gender ? ResponsibleInfo.Gender : 0}
                                        >
                                            <Select.Item

                                                value={0}>
                                                انتخاب کنید
                                            </Select.Item>
                                            <Select.Item

                                                value={1}>
                                                مرد
                                            </Select.Item>
                                            <Select.Item

                                                value={2}>
                                                زن
                                            </Select.Item>

                                        </Select>
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-6'>
                                        <TextField

                                            onChange={(event) => editResponsibleInfo('Mobile', event)}

                                            value={ResponsibleInfo.Mobile ? ResponsibleInfo.Mobile : ''}
                                            label='  تلفن همراه '

                                        />
                                    </Grid.Item>
                                    {!IsCeo &&
                                        <Grid.Item
                                            size='col-6'>

                                            <TextField

                                                onChange={(event) => editResponsibleInfo('JobPosition', event)}

                                                value={ResponsibleInfo.JobPosition ? ResponsibleInfo.JobPosition : ''}
                                                label='  سمت سازمانی '

                                            />
                                        </Grid.Item>
                                    }

                                    <Grid.Item
                                        size='col-6'>
                                        <TextField

                                            onChange={(event) => editResponsibleInfo('Email', event)}

                                            value={ResponsibleInfo.Email ? ResponsibleInfo.Email : ''}
                                            label='  ایمیل (اختیاری) '

                                        />
                                    </Grid.Item>
                                </Grid.Wrapper>
                                <Grid.Item
                                    size='col-12'>
                                    <Button
                                        ms={{
                                            padding: '8px 20px'
                                        }}
                                        type="submit"
                                        className={``}
                                        variant='filled'
                                        color='primary'>
                                        ذخیره اطلاعات
                                    </Button>
                                    <Button
                                        ms={{
                                            padding: '8px 20px'
                                        }}
                                        onClick={() => resetForm()}
                                        className={`mx-md`}
                                        variant='outlined'
                                        color='primary'>
                                        انصراف
                                    </Button>
                                </Grid.Item>
                            </Grid.Item>
                            <Grid.Item
                                size='col-4'>
                                <Image
                                    src={profileImg}
                                    ms={{
                                        background: '#F5F5F7',
                                        borderRadius: '16px'

                                    }}
                                />
                            </Grid.Item>

                        </Grid.Wrapper>

                    </Grid>

                </Box>

            </form>
            <>

                {(!Success && Errs) && Errs.map((err, index) => (
                    <Alert key={index} className={`alert ${alertStatus}`}
                        color={alertColor}
                        ms={{
                            bottom: index == 0 ? (index + 1) * 50 + 'px !important' : index * 50 + 'px !important'
                        }}>
                        {err}
                    </Alert>
                ))}

            </>
            {Success && <Alert
                className={`alert ${alertStatus}`}
                color={alertColor}
                ms={{
                    bottom: '75px !important'
                }} >
                {alert}


            </Alert>}

        </React.Fragment>
    )
            }